export const defaultLocale = 'de';
